import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import Modal from "react-modal";
import "leaflet/dist/leaflet.css";
import Drawer2 from "./Drawer2";
// Fix for default marker icons in Leaflet
import L, { setOptions } from "leaflet";
import { useFetchData } from "../../hooks/useFetchData";
import GeoSearchBar from "../../ui/Geo";
import Range from "../../ui/Range";
import Grid from "@mui/material/Grid";
import Option from "../../ui/Option";
import { AreaOptions, FloorOptions, priceOptions } from "../../data";
import Cardd from "../../ui/Card";
import axios from "axios";

import { useTranslation } from "react-i18next";
import {
  GeoSearchControl,
  OpenStreetMapProvider,
  SearchControl,
} from "leaflet-geosearch";
import customIconUrl from "../../component/images/projectlocation.png";
import { TestLanguage } from "../../hooks/testLanguage";
import { Cityauto } from "../../ui/Cityauto";
import { Regionauto } from "../../ui/Regionauto";

let DefaultIcon = L.icon({
  iconUrl: customIconUrl,
  // shadowUrl: iconShadow,
  iconSize: [30, 30],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  // shadowSize: [41, 41],
});

const Projectpage = () => {
  L.Marker.prototype.options.icon = DefaultIcon;

  // Set app element for accessibility (for react-modal)
  Modal.setAppElement("#root");
  const { t } = useTranslation();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [datacard, setDatacard] = useState(null);
  const [offertype, setOffertype] = React.useState(null);
  const [region, setRegion] = React.useState(null);
  const [datasort, setDatasort] = useState();
  const [data2, setData2] = useState();
  const [value, setValue] = useState();
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [regions, setRegions] = useState([]);
  const [status, setStatus] = useState();

  const [filters, setFilters] = useState({
    area_from: null,
    area_to: null,
    price_from: null,
    price_to: null,
    offertype_id: null,
    direction_id: null,
    contract_id: null,
    city_id: null,
    status_id: null,
    region_id: null,
    offertype_category_id: null,
  });
  useEffect(() => {
    try {
      const res = axios.get(
        `${process.env.REACT_APP_API_URL}units?include=status,offertype,direction,contract`
      );
      console.log("hidfgrhty", res.data);
      setData2(res.data);
    } catch (error) {
      console.error("API error:", error);
    }
  }, [data2]);
  useEffect(() => {
    handleApi();
  }, [value]);

  const handleradio = (e) => {
    const newValue = e.target.value;
    setStatus(newValue);
    console.log("status", newValue); // ✅ logs the selected value correctly
  };
  const handlesort = (e) => {
    const selected = e.target.value;
    setValue(selected);
  };
  // try {
  //   const res = await axios.get(`http://3dfinal.tanaghomtech.com/public/api/units?sort=${value}`);
  //   console.log("hi", res.data.data);
  //   setDatasort(res.data.data);
  // } catch (error) {
  //   console.error("API error:", error);
  // }

  const buildApiUrl = (filters) => {
    const {
      area_from,
      area_to,
      price_from,
      price_to,
      offertype_id,
      direction_id,
      status_id,
      city_id,
      region_id,
      offertype_category_id,
    } = filters;
    const params = [];
    const addParam = (key, value) => {
      if (value !== undefined && value !== null && value !== "") {
        params.push(`filter[${key}]=${value}`);
      }
    };
 addParam("user_id", localStorage.getItem("userId"));
    addParam("status_id", status);
    addParam("city_id", city_id);
    addParam("region_id", region_id);
    addParam("direction_id", direction_id);
    addParam("offertype_id", offertype_id);
    addParam("offertype.category_id", offertype_category_id);

    if (price_from && price_to) {
      addParam("PriceBetween", `${price_from},${price_to}`);
    }

    if (area_from && area_to) {
      addParam("AreaBetween", `${area_from},${area_to}`);
    }
    if (value) {
      params.push(`sort=${value}`);
    }
    const queryString = params.join("&");
    const url = `${process.env.REACT_APP_API_URL}units?filter[post.post_status_id]=4&${queryString}`;

    console.log("Clean URL:", url);
    return url;
  };

  const url = process.env.REACT_APP_API_URL + "pointsprojects";

  // Sample data for points on the map
  const { data, isLoading, error } = useFetchData(url, "users");
  console.log("lll", data?.data);

  const openModal = (data) => {
    console.log("data", data);

    setSelectedPoint(data);
    setModalIsOpen(true);
    console.log("data", data);
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };
  const handleOptionChange = (name, selectedItem) => {
    console.log(name);

    if (!selectedItem) return;

    const id =
      selectedItem?.[name]?.id || // if name is 'directions' and selectedItem.directions.id exists
      selectedItem?.id || // fallback: maybe item is directly like { id: 1 }
      null;
    if (
      name === "Price" ||
      name === "area" ||
      name === "Directions" ||
      name === "Type" ||
      name === "Categories" ||
      name === "City" ||
      name === "Region" ||
      name === "Status" ||
      name === "السعر" ||
      name === "المساحة" ||
      name === "الاتجاه" ||
      name === "النوع" ||
      name === "الفئة" ||
      name === "المدينة" ||
      name === "المنطقة" ||
      name === "الحالة"
    ) {
      setFilters((prev) => ({
        ...prev,
        ...((name === "Directions" || name === "الاتجاه") && {
          direction_id: `${id}`,
        }),
        ...((name === "Type" || name === "النوع") && { offertype_id: `${id}` }),
        ...((name === "Status" || name === "الحالة") && { status_id: `${id}` }),
        ...((name === "City" || name === "المدينة") && { city_id: `${id}` }),
        ...((name === "Region" || name === "المنطقة") && {
          region_id: `${id}`,
        }),
        ...((name === "Categories" || name === "الفئة") && {
          offertype_category_id: `${id}`,
        }),
        ...((name === "Price" || name === "السعر") && {
          PriceBetween: `${id},${id}`,
        }),
        ...((name === "area" || name === "المساحة") && {
          AreaBetween: `${id},${id}`,
        }),
      }));
    } else if (name.endsWith("_from") || name.endsWith("_to")) {
      setFilters((prev) => ({
        ...prev,
        ...(name === "price_from" && { [name]: parseFloat(selectedItem) }),
        ...(name === "price_to" && { [name]: parseFloat(selectedItem) }),
        ...(name === "floor_from" && { [name]: parseFloat(selectedItem) }),
        ...(name === "floor_to" && { [name]: parseFloat(selectedItem) }),
        ...(name === "area_from" && { [name]: parseFloat(selectedItem) }),
        ...(name === "area_to" && { [name]: parseFloat(selectedItem) }),
        [name]: parseFloat(selectedItem),
      }));
    }

    console.log("Updated filters:", {
      ...filters,
      ...(name === "price_from" && { [name]: parseFloat(selectedItem) }),
      ...(name === "price_to" && { [name]: parseFloat(selectedItem) }),
      ...(name === "floor_from" && { [name]: parseFloat(selectedItem) }),
      ...(name === "floor_to" && { [name]: parseFloat(selectedItem) }),
      ...(name === "area_from" && { [name]: parseFloat(selectedItem) }),
      ...(name === "area_to" && { [name]: parseFloat(selectedItem) }),
      ...(name === "directions" && { direction_id: id }),
      ...(name === "type" && { offertype_id: id }),
      ...(name === "status" && { contract_id: id }),
    });
  };

  const DrawerComponent = Drawer2;
  console.log(selectedPoint?.id);

  const handleApi = async () => {
    console.log("hi", filters);
    const url = buildApiUrl(filters);
    try {
      const res = await axios.get(url);
      console.log("hi", res.data.data);
      setDatacard(res.data.data);
    } catch (error) {
      console.error("API error:", error);
    }
  };

  return (
    <>
      {/* <NewsBar datanews={datanews} openModal={openModal} /> */}
      <Grid
        sx={{
          overflowY: { xs: "scroll", md: "hidden" },
          display: { xs: "none", md: "block" },
        }}
        item
        size={{ xs: 12, md: 8 }}
      >
        <MapContainer
          center={[33.5, 36.28]}
          zoom={7}
          style={{ width: "100%", height: "90vh", overflowY: "hidden" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          {data?.data?.map((point) => {
            const lat = parseFloat(point.latitude);
            const lng = parseFloat(point.longitude);

            // ✅ تأكد أن القيم صالحة
            if (isNaN(lat) || isNaN(lng)) return null;

            return (
              <Marker
                key={point.id}
                position={[lat, lng]}
                eventHandlers={{
                  mouseover: (e) => e.target.openPopup(),
                  mouseout: (e) => e.target.closePopup(),
                  click: () => openModal(point),
                }}
              >
                <Popup>
                  <div className="popup-container">
                    <img
                      src={`http://3dfinal.tanaghomtech.com/storage/app/public/${point.image}`}
                      alt={TestLanguage(point, "name")}
                      className="popup-image"
                      style={{
                        width: "130px",
                        height: "100px",
                        borderRadius: "8px",
                        objectFit: "cover",
                      }}
                    />
                    <p
                      className="popup-text"
                      style={{ textAlign: "center", fontSize: "12px" }}
                    >
                      {TestLanguage(point, "name")}
                    </p>
                  </div>
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </Grid>{" "}
      {selectedPoint && (
        <DrawerComponent
          point={selectedPoint?.id}
          isOpen={modalIsOpen}
          onClose={closeModal}
        >
            <h2>{TestLanguage(selectedPoint?.offertype, "name")}</h2>
          <h2>{TestLanguage(selectedPoint, "name")}</h2>
          <p>{TestLanguage(selectedPoint, "description")}</p>
        </DrawerComponent>
      )}
    </>
  );
};

export default Projectpage;
